import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';
import { Link, useNavigate } from 'react-router-dom';

export default function Home() {
  const services = [
    {
      name: 'Full Detail',
      description: 'Complete interior & exterior cleaning',
      icon: 'ri-car-line',
      price: 'Starting at $110'
    },
    {
      name: 'Interior Detail',
      description: 'Deep interior cleaning & protection',
      icon: 'ri-steering-2-line',
      price: 'Starting at $65'
    },
    {
      name: 'Exterior Detail',
      description: 'Wash, wax & exterior protection',
      icon: 'ri-drop-line',
      price: 'Starting at $60'
    },
    {
      name: 'Wax Sealant',
      description: 'Premium protection & shine',
      icon: 'ri-shield-star-line',
      price: '$40 add-on'
    }
  ];

  const whyChooseUs = [
    {
      icon: 'ri-map-pin-line',
      title: 'Mobile Service',
      description: 'We come to you — home, office, or anywhere convenient'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Affordable Pricing',
      description: 'Clear, upfront pricing with no hidden fees'
    },
    {
      icon: 'ri-refresh-line',
      title: 'Maintenance Plans',
      description: 'Keep your car looking great with regular service'
    },
    {
      icon: 'ri-award-line',
      title: 'Premium Add-ons',
      description: 'Tire shine & wax sealant upgrades available'
    },
    {
      icon: 'ri-heart-line',
      title: 'Satisfaction Focused',
      description: 'Quality results that exceed your expectations'
    }
  ];

  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative min-h-screen flex items-center bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(https://static.readdy.ai/image/e88ada64db3193888b9a84ae586990c8/430573815b14db54c5c035eb17066b77.jpeg)'
        }}
      >
        <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center text-white">
            <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight text-white">
              Professional Mobile Detailing
              <span className="block text-red-600">We Bring the Shine to You</span>
            </h1>
            <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto text-white">
              Full Interior & Exterior Detailing | Wax Sealant | Maintenance Plans
              <span className="block mt-2 text-red-600 font-semibold">Serving North Carolina</span>
            </p>
            <button
              onClick={() => navigate('/contact')}
              className="font-semibold rounded-lg transition-colors duration-200 cursor-pointer whitespace-nowrap flex items-center justify-center gap-2 bg-red-600 hover:bg-red-700 text-white text-xl px-10 py-4 mx-auto"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-message-3-line"></i>
              </div>
              Text to Book
            </button>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-black mb-4">
              Why Choose Total Care Detailing?
            </h2>
            <p className="text-xl text-black max-w-3xl mx-auto">
              We're committed to providing exceptional mobile detailing services that fit your schedule and exceed your expectations.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {whyChooseUs.map((feature, index) => (
              <div key={index} className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
                <div className="w-12 h-12 flex items-center justify-center bg-red-100 rounded-lg mb-6">
                  <i className={`${feature.icon} text-2xl text-red-600`}></i>
                </div>
                <h3 className="text-xl font-semibold text-black mb-3">{feature.title}</h3>
                <p className="text-black">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Popular Services */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-black mb-4">
              Popular Services
            </h2>
            <p className="text-xl text-black">
              Professional detailing services tailored to your vehicle's needs
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
            {services.slice(0, 4).map((service, index) => (
              <div key={index} className="bg-white border border-gray-200 rounded-xl p-8 hover:shadow-lg transition-shadow">
                <div className="w-12 h-12 flex items-center justify-center bg-red-100 rounded-lg mb-6">
                  <i className={`${service.icon} text-2xl text-red-600`}></i>
                </div>
                <h3 className="text-xl font-semibold text-black mb-3">{service.name}</h3>
                <p className="text-black mb-4">{service.description}</p>
                <p className="text-lg font-semibold text-red-600">{service.price}</p>
              </div>
            ))}
          </div>
          
          <div className="text-center">
            <Link to="/services">
              <Button size="lg" variant="outline" className="border-red-600 text-red-600 hover:bg-red-600 hover:text-white">
                View All Services
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Hours */}
      <section className="py-20 bg-black text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-8">Business Hours</h2>
          <div className="bg-gray-900 rounded-xl p-8 max-w-md mx-auto">
            <div className="flex items-center justify-center mb-4">
              <div className="w-8 h-8 flex items-center justify-center mr-3">
                <i className="ri-time-line text-2xl text-red-600"></i>
              </div>
              <h3 className="text-xl font-semibold">Weekend Service</h3>
            </div>
            <p className="text-lg mb-2">Saturday – Sunday</p>
            <p className="text-2xl font-bold text-red-600">10:00 AM – 6:30 PM</p>
            <p className="text-gray-400 mt-4">(Closed Monday–Friday)</p>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 bg-red-600 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="w-16 h-16 flex items-center justify-center bg-white rounded-full mx-auto mb-6">
            <i className="ri-message-3-fill text-3xl text-red-600"></i>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Ready to Book?</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            To book, text 980-261-1286 and we'll give you a quote
          </p>
          <a 
            href="sms:+19802611286" 
            className="inline-block bg-white text-red-600 hover:bg-black hover:text-white font-semibold rounded-lg transition-colors duration-200 cursor-pointer whitespace-nowrap px-10 py-4 text-lg"
          >
            Text Us Now
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
